const headerLoaderScript = document.currentScript;
const searchBarSource = headerLoaderScript?.dataset.searchBarSource;
const b2bPriceHydrationSource = headerLoaderScript?.dataset.b2bPriceHydrationSource;
let searchBarPromise;
let b2bPriceHydrationPromise;

function loadB2BPriceHydration() {
  if (!b2bPriceHydrationSource || window.B2BPriceHydration) return Promise.resolve();

  b2bPriceHydrationPromise ||= import(b2bPriceHydrationSource).catch((error) => {
    console.warn('[header-loader] B2B price hydration could not be loaded:', (error && error.message) || error);
  });
  return b2bPriceHydrationPromise;
}

window.B2BPriceHydrationLoader = { load: loadB2BPriceHydration };

function loadSearchBar() {
  if (!searchBarSource || customElements.get('search-bar')) return Promise.resolve();

  searchBarPromise ||= loadB2BPriceHydration().then(() => import(searchBarSource));
  return searchBarPromise;
}

document.querySelectorAll('search-bar').forEach((searchBar) => {
  searchBar.addEventListener('pointerenter', loadSearchBar, { once: true });
  searchBar.addEventListener('focusin', loadSearchBar, { once: true });
  searchBar.addEventListener('touchstart', loadSearchBar, { once: true, passive: true });
});

document.addEventListener(
  'click',
  async (event) => {
    if (customElements.get('search-bar') || !(event.target instanceof Element)) return;

    const toggle = event.target.closest('search-bar .header__search-toggle');
    if (!toggle) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    await loadSearchBar();
    toggle.click();
  },
  true,
);
